<div class="modal">
    <a (click)="closeDialog()" class="close"><mat-icon>close</mat-icon></a>
    <h1>Aviso de privacidad</h1>
    <div class="texto" [innerHTML]="repuesta.texto">
    </div>
</div>